import { api } from './client';

/*  Specchio dei contratti di TeraWorks.Application.Rapportini, lato ufficio.

    Il lato telefono è un'altra cosa e sta in features/rapportini/coda.ts: quello accumula
    e sincronizza senza rete, questo legge e decide. Tenerli separati non è duplicazione —
    sono due letture diverse dello stesso rapportino, e l'unica cosa che condividono è
    l'identificativo.  */

export type StatoRapportino = 'Bozza' | 'Inviato' | 'Approvato' | 'Respinto';

export interface RigaOreLetta {
  id: string;
  commessaId: string;
  commessa: string | null;
  cliente: string | null;
  ore: number;
  tipoLavorazione: string | null;
  descrizione: string | null;
}

export interface RigaMaterialeLetta {
  id: string;
  commessaId: string;
  commessa: string | null;
  descrizione: string;
  quantita: number;
  unitaMisura: string | null;
  siglaProduttore: string | null;
  codiceArticoloProduttore: string | null;
  daCodificare: boolean;
}

/*  Una trasferta come la legge chi valida. `importo` arriva già fatto dal server: la
    formula sta nel dominio, e ricalcolarla qui vorrebbe dire due implementazioni della
    stessa regola che prima o poi si smentiscono. Tariffa e quota ci sono comunque, perché
    un totale che non si può scomporre non si può controllare.  */
export interface RigaTrasfertaLetta {
  id: string;
  commessaId: string;
  commessa: string | null;
  km: number;
  tariffaKm: number;
  quotaIndennita: number;
  importo: number;
  note: string | null;
}

export interface DettaglioRapportino {
  id: string;
  idDispositivo: string;
  operaioId: string;
  operaio: string | null;
  dataLavoro: string;
  stato: StatoRapportino;
  compilatoIlDispositivo: string | null;
  sincronizzatoIl: string | null;
  approvatoIl: string | null;
  approvatoDa: string | null;
  motivoRespinta: string | null;
  note: string | null;
  oreTotali: number;
  /** Costo orario di oggi dell'operaio: null se non è in anagrafica, non zero. */
  costoOrarioOggi: number | null;
  costoOreOggi: number | null;
  /** Vero solo su un rapportino inviato: le due decisioni esistono solo lì. */
  decidibile: boolean;
  /** L'indennità del giorno, una sola anche con tre cantieri. */
  indennitaGiornaliera: number;
  trasferteTotali: number;
  ore: RigaOreLetta[];
  materiali: RigaMaterialeLetta[];
  trasferte: RigaTrasfertaLetta[];
}

/*  La correzione di chi valida. `km` null vuol dire «questa trasferta non c'è»: è il modo
    di toglierla senza una seconda rotta, e il modo in cui lo dice chi guarda — «su questo
    cantiere non ci è andato».  */
export interface CorrezioneTrasferta {
  commessaId: string;
  km: number | null;
  note?: string | null;
}

export const rapportini = {
  leggi: (id: string) => api.get<DettaglioRapportino>(`/rapportini/${id}`),

  approva: (id: string) => api.post<DettaglioRapportino>(`/rapportini/${id}/approva`, {}),

  respingi: (id: string, motivo: string) =>
    api.post<DettaglioRapportino>(`/rapportini/${id}/respingi`, { motivo }),

  /** Corregge i chilometri prima di approvare: è l'ultimo momento in cui costano zero. */
  correggiTrasferte: (id: string, righe: CorrezioneTrasferta[]) =>
    api.post<DettaglioRapportino>(`/rapportini/${id}/trasferte`, { righe }),
};
